var _rect, _rect2, _rect3, _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_341_13463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_341_13463)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#05AB41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53168 10.5597C3.12568 10.297 3.12568 9.70301 3.53168 9.44031L13.6378 2.90103C13.8582 2.75843 14.1418 2.75843 14.3622 2.90103L24.4683 9.44031C24.8743 9.70301 24.8743 10.297 24.4683 10.5597L14.3622 17.099C14.1418 17.2416 13.8582 17.2416 13.6378 17.099L3.53168 10.5597Z",
    fill: "#FDD216"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14.6666C16.5773 14.6666 18.6667 12.5773 18.6667 9.99998C18.6667 7.42265 16.5773 5.33331 14 5.33331C11.4227 5.33331 9.33333 7.42265 9.33333 9.99998C9.33333 12.5773 11.4227 14.6666 14 14.6666Z",
    fill: "#053087"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_341_13463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 10,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14.6666C16.5773 14.6666 18.6667 12.5773 18.6667 9.99998C18.6667 7.42265 16.5773 5.33331 14 5.33331C11.4227 5.33331 9.33333 7.42265 9.33333 9.99998C9.33333 12.5773 11.4227 14.6666 14 14.6666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_341_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.77994 8.78021C9.51264 8.18688 11.877 8.74895 14.0841 9.33769C16.2911 9.92643 18.593 11.1604 19.1791 11.8842",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/BR.c1cf4dcb.svg";
export { ForwardRef as ReactComponent };